// extracted by mini-css-extract-plugin
export default {"reason":"N6kC1BlrqEry3gQBBw24Cg=="};